import { Color, Quaternion, Vector3 } from "three";
import { Constants } from "@managers/physics";
const PlayerConfig = {
    COLOR: new Color(0x6e259c),
    POSITION: new Vector3(0, 10, 0),
    ROTATION: new Quaternion(),
    DIMENSIONS: new Vector3(0.5, 1, 0.5),
    MAX_HEALTH: 100,
    MAX_SLOPE: Math.PI / 3,
    JUMP_SPEED: Constants.GRAVITY / 1.6,
    MAX_JUMP_HEIGHT: 1.5,
    BASE_SPEED: 0.2,
    CAST_SHADOW: true,
    RECEIVE_SHADOW: false,
};
export { PlayerConfig };
